// extracted by mini-css-extract-plugin
export default {"wrap":"assetCreate_wrap__KlS56","container":"assetCreate_container__o4Y7I"};